import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { MarkNotificationsReadRequest, NotificationsResponse } from '@wf/shared'
import { api } from '../api/client'

/**
 * Eigene Benachrichtigungen + Ungelesen-Zähler (Glocke & Reiter-Badges speisen sich daraus). Ein sanfter
 * Poll hält die Anzeige aktuell, bis der Push-Kanal (P2) das Refetch per SW-postMessage anstößt; zusätzlich
 * frischt TanStack bei Fokuswechsel auf. Läuft nur, solange die Glocke gemountet ist (also eingeloggt).
 */
export function useNotifications() {
  return useQuery({ queryKey: ['notifications'], queryFn: api.notifications, refetchInterval: 45_000 })
}

/**
 * „Gelesen" markieren (eine/alle). Die Antwort trägt die frischen Zähler → wir aktualisieren den Cache
 * direkt (Badge fällt sofort), ohne einen zweiten Request. Serverseitig ist die Operation idempotent.
 */
export function useMarkNotificationsRead() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: MarkNotificationsReadRequest) => api.markNotificationsRead(body),
    onSuccess: (res, vars) => {
      qc.setQueryData<NotificationsResponse>(['notifications'], (prev) => {
        if (!prev) return prev
        const all = vars.all === true
        const ids = new Set(vars.ids ?? [])
        const readStamp = new Date().toISOString()
        const items = prev.items.map((n) => ((all || ids.has(n.id)) && !n.readAt ? { ...n, readAt: readStamp } : n))
        return { items, unreadTotal: res.unreadTotal, unreadByArea: res.unreadByArea }
      })
    },
  })
}
